<script lang="ts">
  interface Properties {
    /** True when this stop is already in the favorites list. */
    starred: boolean;
    /** Fires on click; caller flips the persisted state. */
    onToggle: () => void;
  }

  const { starred, onToggle }: Properties = $props();

  const label = $derived(starred ? 'Remove from favorites' : 'Add to favorites');
  const glyph = $derived(starred ? '★' : '☆');
</script>

<!-- One-glyph star toggle. Filled star = starred, hollow = not. Screen readers
     get the state via `aria-pressed` and the descriptive `aria-label`. -->
<button
  type="button"
  class="favorite-star"
  class:starred
  aria-pressed={starred}
  aria-label={label}
  onclick={onToggle}
>
  {glyph}
</button>

<style>
  .favorite-star {
    background: none;
    border: none;
    color: var(--color-fg-muted);
    cursor: pointer;
    font-size: 1.1rem;
    line-height: 1;
    padding: 0 4px;
  }

  .favorite-star:hover {
    color: var(--color-warn);
  }

  .favorite-star.starred {
    color: var(--color-warn);
  }
</style>
